import createVueComponent from '../createVueComponent';

const IterationCw = createVueComponent('IterationCwIcon', [
  ['path', { d: 'M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4', key: 'tuf4su' }],
  ['polyline', { points: '8 22 4 18 8 14', key: 'evkj9s' }],
]);

export default IterationCw;
